export const upperAllFirst = (text: string = "") =>
	text
		.split(" ")
		.map((item) => (item.length >= 1 ? item[0].toUpperCase() + item.slice(1) : item))
		.join(" ");

export const upperFirst = (text: string = "") => (text?.length >= 1 ? text[0].toUpperCase() + text.slice(1) : text);

export const isStringNumber = (value: any) =>
	["string", "number"].includes(typeof value) && value !== "" && !isNaN(Number(value));
